


function Options({question, dispatch, answer}) {
    const hasAnswered = answer !==null;
    return (
        <div>
            <div className="options">
                {question.options.map((option, index)=>
                    <button className={
                    `btn btn-option ${index===answer? 'answer': ''} 
                    ${ 
                    hasAnswered ?
                        index===question.correctOption? 'correct' : 'wrong' 
                    : null}`} 
                    disabled={hasAnswered}
                    key={option} onClick={()=>dispatch({type: 'newAnswer', payload: index})} >{option} 
                    
                    </button>
                 
                    )
                }
              

            </div>
        </div>
    )
}

export default Options
